module.exports = __webpack_public_path__ + "static/img/water.88e1712.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/tools/water.png
// module id = 461
// module chunks = 1